export const getDefaultImage = (
  crops: {
    url: string
    width: number
  }[],
) => {
  const sortedSrcs = crops.slice().sort((a, b) => b.width - a.width)
  const midpointInArray = Math.floor(sortedSrcs.length / 2)

  return sortedSrcs[midpointInArray]?.url || ''
}

export const getSrcSet = (
  crops: {
    url: string
    width: number
  }[],
) => crops.map((src) => `${src.url} ${src.width}w`).join(', ')
